import { Component, type ReactNode } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface Props { children: ReactNode; }
interface State { error: Error | null; }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div className="min-h-screen bg-felt-900 flex flex-col items-center justify-center p-8 text-center gap-6">
          <div className="w-16 h-16 rounded-2xl bg-red-950/60 border border-red-900/50
                          flex items-center justify-center mx-auto">
            <AlertTriangle size={28} className="text-red-400" strokeWidth={1.5} />
          </div>
          <div>
            <h1 className="font-display text-gold-400 text-xl font-semibold tracking-widest uppercase mb-2">
              Something went wrong
            </h1>
            <p className="text-gray-500 text-sm max-w-xs mx-auto leading-relaxed">
              {error.message || 'An unexpected error occurred.'}
            </p>
          </div>
          <button
            onClick={() => window.location.reload()}
            className="flex items-center gap-2 px-6 py-3 rounded-xl bg-felt-700 hover:bg-felt-600
                       text-white font-bold border border-felt-600 transition-colors
                       focus-visible:ring-2 focus-visible:ring-gold-400 outline-none"
          >
            <RefreshCw size={16} strokeWidth={1.5} />
            Reload app
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
